var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.76.758a.525.525 0 01.48 0l5.775 2.975c.175.09.285.27.285.467v5.6c0 .197-.11.377-.285.467L7.24 13.242a.525.525 0 01-.48 0L.985 10.267A.525.525 0 01.7 9.8V4.2c0-.196.11-.376.285-.467L6.76.758zm-5.01 4.28V9.48l4.725 2.434V7.33L1.75 5.04zM7.525 7.33v4.585L12.25 9.48V5.038L7.525 7.33zM11.6 4.186l-1.754.85-4.618-2.308L7 1.816l4.6 2.37zm-7.528-.862l-1.674.862 4.6 2.23 1.656-.802-4.582-2.29z",
    fill: "#555F6D"
  })));
}
export default SvgBoxSmall;